var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "position-relative mb-1" }, [
      _c("div", { staticClass: "ob1-skeleton py-1" }, [
        _c("div", { staticClass: "ob1-skeleton-gray2 back-button" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg-primary3 banner" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bg-white text-black px-2 pb-1 mt-5 content-overlay" },
        [
          _c("div", { staticClass: "ob1-skeleton mb-1" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 d-flex justify-content-between position-relative",
                },
                [
                  _c("div", {
                    staticClass:
                      "ob1-skeleton-gray2 tag-skeleton align-self-start",
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "ob1-skeleton-white product-image-skeleton",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex mt-1 justify-content-between w-100" },
                [
                  _c("div", { staticClass: "w-75 me-2" }, [
                    _c("div", {
                      staticClass:
                        "ob1-skeleton-white ob1-skeleton-margin title-skeleton",
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "ob1-skeleton-white ob1-skeleton-margin sub-title-skeleton",
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-25 d-flex flex-column align-items-end" },
                    [
                      _c("div", {
                        staticClass: "ob1-skeleton-white price-skeleton",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "ob1-skeleton-white ob1-skeleton-margin price-info-skeleton",
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "separator separator--gray4 w-100" }),
          _vm._v(" "),
          _c("div", { staticClass: "ob1-skeleton my-1" }, [
            _c("div", { staticClass: "d-flex my-1 align-items-start mb-1" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white feature-icon me-1",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column w-100" }, [
                _c("div", { staticClass: "ob1-skeleton-white feature-text" }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-text",
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-link",
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex my-1 align-items-start mb-1" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white feature-icon me-1",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column w-100" }, [
                _c("div", { staticClass: "ob1-skeleton-white feature-text" }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-text",
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-link",
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex my-1 align-items-start mb-1" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white feature-icon me-1",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column w-100" }, [
                _c("div", { staticClass: "ob1-skeleton-white feature-text" }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-text",
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-link",
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex my-1 align-items-start mb-1" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white feature-icon me-1",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column w-100" }, [
                _c("div", { staticClass: "ob1-skeleton-white feature-text" }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-text",
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-link",
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex my-1 align-items-start mb-1" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white feature-icon me-1",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column w-100" }, [
                _c("div", { staticClass: "ob1-skeleton-white feature-text" }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-text",
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ob1-skeleton-white ob1-skeleton-margin feature-link",
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "separator separator--gray4 w-100" }),
          _vm._v(" "),
          _c("div", { staticClass: "ob1-skeleton my-1" }, [
            _c("div", { staticClass: "ob1-skeleton-white back-button" }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }